import get from "lodash/get";
import { lookup } from "mime-types";

import { Entry, EntryType } from "../types";
import { DropboxEntry } from "./types";

const mimeMap = new Map<string | boolean, EntryType>([
  ["folder", EntryType.folder],
  ["application/epub+zip", EntryType.epub],
  ["application/msword", EntryType.doc],
  ["application/vnd.openxmlformats-officedocument.wordprocessingml.document", EntryType.doc],
  ["application/pdf", EntryType.pdf],
  ["text/plain", EntryType.txt],
  [false, EntryType.unknown],
]);

export const convertEntry = (entry: DropboxEntry): Entry => ({
  id: entry.id,
  name: entry.name,
  type: mimeMap.get(entry[".tag"]) || mimeMap.get(lookup(entry.name)) || EntryType.unknown,
  size: get(entry, "size"),
  createdTime: get(entry, "server_modified"),
});
